import { useRef } from 'react';
import { ArrowRight, Send } from 'lucide-react';
import { Button } from '../../../components';
import { useLang } from '../../../i18n';
import { useLeadModal } from '../../../contexts/LeadModalContext';
import useIntersectionFadeIn from '../../../hooks/useIntersectionFadeIn';

export default function CtaSection() {
  const { t } = useLang();
  const { openModal } = useLeadModal();
  const rootRef = useRef<HTMLElement>(null);
  const visible = useIntersectionFadeIn(rootRef);

  return (
    <section
      ref={rootRef}
      id="lead-form"
      className={`section section--dark cta scroll-fade-in${visible ? ' scroll-fade-in--visible' : ''}`}
    >
      <div className="cta__pattern-left tech-pattern tech-pattern--on-dark" aria-hidden="true" />
      <div className="cta__pattern-right tech-pattern tech-pattern--on-dark" aria-hidden="true" />
      <div className="container cta__inner">
        <span className="eyebrow cta__eyebrow">{t('home.cta.eyebrow')}</span>
        <h2 className="cta__title">{t('home.cta.title')}</h2>
        <p className="lead cta__lead">{t('home.cta.sub')}</p>

        <div className="cta__actions">
          <Button
            variant="primary"
            size="lg"
            onClick={() => openModal()}
            iconRight={<ArrowRight size={18} />}
          >
            {t('home.hero.cta1')}
          </Button>
          <a
            className="cta__tg"
            href="https://t.me/mrbek112"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Send size={18} />
            <span>{t('home.cta.telegram')}</span>
          </a>
        </div>

        <div className="cta__sig">{t('home.cta.sig')}</div>
      </div>
    </section>
  );
}
